import {request,newVue,requestMsg} from "./request";
export {newVue}

export function getDailyPushBySearch(date,skuNo,pageNum,pageSize) {
  return request({
    url: '/dailyPush/getDailyPushList',
    params: {
      date: date,
      skuNo: skuNo,
      pageNum: pageNum,
      pageSize: pageSize
    }
  })
}

export function delByDailyPushId(id) {
  return requestMsg({
    url: '/dailyPush/delByDailyPushId',
    params: {
      dailyPushId: id,
    }
  })
}
